import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConversionsPipe } from './conversions.pipe';
import { DurationPipe } from './duration.pipe';


@NgModule({
  declarations: [ConversionsPipe, DurationPipe],
  imports: [
    CommonModule
  ],
  exports: [ConversionsPipe, DurationPipe]
})
export class SharedPipeModule { }
